<section class="loginPage">
    <div class="container">
        <div class="verificationWrap setPassword">
            <a href="javascript:void(0);" routerLink="/settings" class="bkbtn mb-2"><img
                    src="assets/images/arrow_back.svg" class="ht"> Back</a>
            <div class=" subHeader">
                <h2 class="mainTitle"> Delete Account</h2>
                <p> Enter your current password. </p>
            </div>
            <form [formGroup]="form" (ngSubmit)="submitPassword()">
                <div class="form-group mb-4">
                    <label>Password </label>
                    <input type="{{showPwd?'text':'password'}}" class="form-control" name="password"
                        placeholder="Password" id="password" formControlName="password" />
                    <a href="javascript:void(0);" [class]="showPwd? 'hide':'show'" (click)="showPwd= !showPwd">
                        <img class="hide"
                            [src]="showPwd? '../../../assets/images/password.svg':'../../../assets/images/ic_eye_open.svg'"
                            alt="password">
                        <i></i>
                    </a>
                    <div class="text-danger" *ngIf="form.controls['password'].hasError('required') && showError">
                        *Please enter password.
                    </div>
                </div>
                <div class="form-group mb-4">
                    <label>Confirm Password </label>
                    <input type="{{showReNewPwd?'text':'password'}}" class="form-control" name="confirmPassword"
                        placeholder="Confirm Password" formControlName="confirmPassword" />
                    <a href="javascript:void(0);" [class]="showReNewPwd? 'hide':'show'"
                        (click)="showReNewPwd= !showReNewPwd">
                        <img class="hide"
                            [src]="showReNewPwd? '../../../assets/images/password.svg':'../../../assets/images/ic_eye_open.svg'"
                            alt="password">
                        <i></i>
                    </a>
                    <div class="text-danger"
                        *ngIf="(showError) || ((form.value.newPassword && form.value.confirmPassword) && (form.value.newPassword != form.value.confirmPassword))">
                        *Password does not match. Please try again.
                    </div>
                </div>
                <div class="form-group">
                    <input type="submit" value="Submit" class="commonBtn mt-5" />
                </div>
            </form>
        </div>
    </div>
</section>

<!-- End -->